// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page[data-v-7db3df9e] {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
